<template>
 <div :class="windowClass">
   
    <v-row dense>
        <v-col
        md="8"
        offset-md="2"
        >
            <v-card
            class="pa-4"
            dark
            :class="margin_class"
            color="primary"
            >   
            <v-text-field 
                v-model="drnumber"
                outlined
                label="Enter D.R. Number"
                clearable
                dense
                filled
                hide-details
                append-outer-icon="mdi-send"
                @click:append-outer="Validate()"
            />
            </v-card>
           
              <v-card
                class="pa-4 mt-2"
                v-if="checked.status"
                >   
                <p>
                      <v-icon left color="primary">mdi-account</v-icon> SALESMAN: {{dr.salesman_name}}  
                      <br />
                      <span class="sm-font pl-1 text-info"><v-icon left small color="primary">mdi-calendar</v-icon> Inbound: {{dr.inbound_date | moment($date_format)}}</span>
                </p>
                <p>
                     <v-icon left color="primary">mdi-format-list-checks</v-icon> STATUS: <span :class="STATUS_TEXT(checked.status)">{{checked.status}} </span>
                </p>
                <v-card-actions>
                  <v-spacer/>
                   <v-btn  small  @click="checked.status='For Verification', Save()" color="success" v-if="checked.status=='On Going'" ><v-icon left >mdi-check</v-icon> For verification</v-btn>
                    <!-- <v-btn small @click="checked.status='Verified', Save()" color="secondary" v-if="checked.status=='For Verification'"> <v-icon left >mdi-check</v-icon>  Verifeid</v-btn> -->
                </v-card-actions>
             </v-card>
             <v-row dense>
               <v-col cols="6">
                <v-card
                    class="mt-2"
                    v-if="checked.status"
                    >   
                    <v-toolbar dense color="primary" dark>
                        RETURNED FULL
                        <v-spacer/>
                         <v-spacer/>
                        <v-icon @click="product_type='content', form=true">mdi-plus-box</v-icon>
                    </v-toolbar>
                    <v-data-table
                        class="va-table mt-2"
                        dense
                        :headers="[{text:'code'},{text:'QTY' , align:'right'}]"
                        disable-sort
                        hide-default-footer
                         disable-pagination
                        :items="checked.full_items"
                        >
                         <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                           <td>
                             <v-icon v-if="checked.status!='Verified'" color="error" @click="product_type='content',removeReturned(index)" left small>mdi-delete</v-icon>
                             {{item.code}}</td>
                            <td class="text-right">
                                <input 
                              type="number"
                                class="va-input pa-1"
                               v-model="item.qty"
                               :disabled="checked.status=='Verified'"
                               @keyup="parseInt(item.qty)"
                               @change="Save()"
                              />
                            </td>
                        </tr>
                        </tbody>
                    </template>
                    </v-data-table>
                </v-card>
               </v-col>
               <v-col cols="6">
                <v-card
                    class="mt-2"
                    v-if="checked.status"
                    >   
                    <v-toolbar dense color="primary" dark>
                        RETURNED EMPTIES
                        <v-spacer/>
                        <v-icon @click="product_type='empties', form=true">mdi-plus-box</v-icon>
                    </v-toolbar>
                     <v-data-table
                        class="va-table mt-2"
                        dense
                        :headers="[{text:'code'},{text:'QTY' , align:'right'}]"
                        disable-sort
                        hide-default-footer
                         disable-pagination
                        :items="checked.empty_items?checked.empty_items:[]"
                        >
                         <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                           <td>
                             <v-icon v-if="checked.status!='Verified'" color="error" @click="product_type='empties',removeReturned(index)" left small>mdi-delete</v-icon>
                             {{item.code}}</td>
                            <td class="text-right">
                                <input 
                              type="number"
                                class="va-input pa-1"
                                  :disabled="checked.status=='Verified'"
                               v-model="item.qty"
                               @change="Save()"
                              />
                            </td>
                        </tr>
                        </tbody>
                    </template>
                    </v-data-table>
                </v-card>
               </v-col>
             </v-row>
      </v-col>
    </v-row>
    <va-checker-form :show="form" :type="product_type" @DialogEvent="formEvent"/>
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
        form: false,
        product_type:'',
        drnumber:'',
        checked: {},
        dr:{}
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
            this.SET_MENUS()
          this.GET_PRODUCTS()
          if(this.$route.params.dr != 'new'){
             this.drnumber = this.$route.params.dr
              this.Validate()
          }
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      fulls(){
         var items =  this.checked.full_items?this.checked.full_items:[]
         var arr = items.reduce((res,item) => {
              item.qty = parseInt(item.qty)
              res.push(item)
              return res
         }, [])
         return arr
      },
      empties(){
         var items =  this.checked.empty_items?this.checked.empty_items:[]
         var arr = items.reduce((res,item) => {
              item.qty = parseInt(item.qty)
              res.push(item)
              return res
         }, [])
           return arr
      },
      margin_class() {
          if(this.checked.status) {
            return 'no-margin-top'
          } else {
              return 'add-margin-top'
          }
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      formEvent(e){
        this.form = false
        if(e != 'close'){
          this.addReturned(e)
        }
      },
      addReturned(item) {
        if(this.product_type == 'empties') {
          this.checked.empty_items?this.checked.empty_items.push(item):this.checked.empty_items=[item]
        } else  if(this.product_type == 'content') {
          this.checked.full_items?this.checked.full_items.push(item):this.checked.full_items=[item]
        }
        this.Save()
      },
       removeReturned(index) {
        if(this.product_type == 'empties') {
         this.checked.empty_items.splice(index, 1)
        } else  if(this.product_type == 'content') {
           this.checked.full_items.splice(index, 1)
        }
        this.Save()
      },
        Validate(){
            this.APPLOADER(true, 'Loading..')
             this.$http.post("delivery/add_report", {dr_number: this.drnumber}).then(response => {
                this.GET_RESPONSE(response)
                if(response.data.status) {
                    response.data.checked!=null?this.checked = response.data.checked: this.checked = {}
                    response.data.delivery!=null?this.dr = response.data.delivery: this.dr = {}
                 }
                setTimeout( () =>{this.APPLOADER(false, '')}, 500)
               }).catch(e => {
                console.log(e.data)
            })
        },
         Save(){
             this.checked.full_items = this.fulls
             this.checked.empty_items =  this.empties
             console.log(this.checked)
             this.$http.post("delivery/save_report", this.checked).then(response => {
                this.GET_RESPONSE(response)
               }).catch(e => {
                console.log(e.data)
            })
        }
      
    },
  }
</script>
<style>
.no-margin-top {
    margin-top: 30;
  }
  
  .add-margin-top {
    margin-top: 30%;
  }

</style>